import { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthProvider";
import { usePermission } from "../../../context/PermissionContext";
import { useContextApi } from "../../../context/ContextApi";
import { useNavigate } from "react-router-dom";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import uRLs from "../../../utils/baseUtils";
import { CircularProgress, Skeleton } from "@mui/material";
import ReactPaginate from "react-paginate";
import PasswordManager from "../customer/CloudPassword/Password";
import EstimateList from "../customer/EstimateList";
import JobCardList from "../customer/JobCardList";
import ViewPaylater from "../paylater/ViewPaylater";
import DeleteModal from "../../../constants/DeleteModal";
import EditCutomer from "./EditSupplier";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import EssentialInvoice from "../../../utils/print/a4Invoices/EssentialInvoice";
import PurchaseView from "../purchase/PurchaseView";
import ProfessionalGSTInvoice from "../../../utils/print/a4Invoices/ProfessionalGSTInvoice";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { BuildingIcon, CreditCardIcon, DeleteIcon, EditIcon, EnvelopeIcon, HomeIcon, IdCardIcon, MapIcon, PhoneIcon, ShowIcon, TimerIcon, UserIcon, XIcon } from "../../../constants/Icons";

const CustomerView = ({
  isOpen,
  onClose,
  supplierId,
  setCustomerData,
  setCustTotalItems,
  onUpdate,
  OnDelete,
  onChangeGroup,
  onEditGroupData,
  selectedGroupDetails,
  groupId,
  onNewGroupsSet,
}) => {
  console.log("customerId in view modal:", supplierId);
  const [activeTab, setActiveTab] = useState("customer");
  const [customerData, setCustomerDetails] = useState(null);
  console.log(customerData);
  const { updateSettings } = useAuth();
  const [salesData, setSalesData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isPaylaterData, setPaylaterData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSearchTerm, setSearchTerm] = useState("");
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [error, setErrors] = useState({});
  const [isDeleteData, setDeleteData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const {
    permission,
    hasModulePermission,
    blockedPermissions,
    activeStoreModules,
    customerGroups,
    hasPermission,
    storeSettings,
  } = usePermission();
  const templateId =
    storeSettings?.invoiceSettings?.template?.templateId || "PROFESSIONALGST";
  const { useEscapeKey } = useContextApi();
  useEscapeKey(onClose);
  // 🔹 Separate loaders
  const [isCustomerLoading, setIsCustomerLoading] = useState(true);
  const [isSalesLoading, setIsSalesLoading] = useState(true);
  const [selectedPurchaseOption, setSelectedPurchaseOption] = useState("PURCHASE");
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
  const [isSelectedPlater, setSelectedPlater] = useState(false);
  const [buttonLoading, setButtonLoading] = useState({ type: "", id: null });
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);
  const [newGroupName, setNewGroupName] = useState(null);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);

  const navigate = useNavigate();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const perPage = 10;

  useEffect(() => {
    if (isOpen && supplierId) {
      fetchCustomerDetails();
    }
  }, [isOpen, supplierId]);

  useEffect(() => {
    if (activeTab === "PurchaseCreditList" && customerData?._id) {
      fetchSalesDetails(customerData._id, currentPage);
    }
  }, [activeTab, customerData, currentPage]);

  const fetchCustomerDetails = async () => {
    try {
      setIsCustomerLoading(true);
      const response = await AxiosInstance.get(`module/supplier/${supplierId}`);
      setCustomerDetails(response.data.results);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsCustomerLoading(false);
    }
  };
  console.log("customerData:", customerData);
  const handleViewPaylater = (customer) => {
    const updatedCustomer = {
      ...customer.customerData,
      customerid: customer.customerData._id,
    };

    setSelectedPlater(updatedCustomer);
  };

  const handleClosePaylater = () => {
    setSelectedPlater(false);
  };

  const handleListPaylater = async (page = 0, term = "") => {
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      // const data = { searchtxt: term, pageno: page + 1, perpage: perPage };
      const response = await AxiosInstance.get(
        `module/paylater?pageno=${page + 1}&limit=${perPage}&searchtxt=${term}`,
      );
      const results = response.data.results || [];
      setPaylaterData(results);

      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleDataUpdate = () => {
    handleListPaylater(currentPage, isSearchTerm);
  };

  const fetchSalesDetails = async (customerId, page = 0) => {
    try {
      setIsSalesLoading(true);
      const response = await AxiosInstance.get(
        `module/purchase/credit?supplierId=${customerId}&pageno=${page + 1}&limit=${perPage}`,
      );
      const { results, totalItems, totalPages } = response.data;
      setSalesData(results || []);
      console.log(salesData);
      setTotalItems(totalItems || 0);
      setTotalPages(totalPages || 0);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setIsSalesLoading(false);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/purchase//${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleView = async (item) => {
    setButtonLoading({ type: "view", id: item._id });
    try {
      const data = await handleSaleItems(item._id);
      if (data) {
        setViewData(data);
        setViewModalOpen(true);
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
      setButtonLoading({ type: "", id: null });
    }
  };

  const handleEdit = (item) => {
    sessionStorage.removeItem("purchaseId"); // ✅ clear old

    navigate("/purchase", {
      state: {
        purchaseData: item,
        isEdit: true,
        navigatelist: "/listpurchase",
      },
      key: item._id,
    });
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "number",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "website",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/supplier/${updatedData._id}`,
        data,
      );

      showAlert("success", Messages.SUCCESS.SUPPLIER_UPDATED);
      setCustomerDetails((prev) => ({
        ...prev,
        ...updatedCustomer, // spread API response into existing details
      }));

      setSelectedCustomer((prev) => ({
        ...prev,
        customerData: updatedCustomer,
      }));

      const updatedCustomer = response.data.results;
      const updatedCustomerId = updatedCustomer?._id;

      const originalGroupId = isEditData?.groupid || "";
      const newGroupId = updatedData.groupid || "";
      const groupIdChanged = originalGroupId !== newGroupId;

      if (setCustomerData) {
        if (groupIdChanged) {
          setCustTotalItems((prevCount) => prevCount + 1);
        }
        setCustomerData((prevCustomerData) => {
          if (groupIdChanged) {
            const filteredData = prevCustomerData.filter(
              (customer) => customer._id !== updatedCustomerId,
            );
            // setCustTotalItems(prevCount => prevCount + 1);
            return [updatedCustomer, ...filteredData];
          } else {
            return prevCustomerData.map((customer) =>
              customer._id === updatedCustomerId ? updatedCustomer : customer,
            );
          }
        });
      } else {
        onUpdate(response.data?.results);
      }
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const openEditModal = (cItem) => {
    if (blockedPermissions("CUSTOMER:view") || permission === undefined) {
      console.log("cItem", cItem);
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  // const handleCustomerGroupAdd = async (groupName, method) => {
  //   setAddGroupLoad(true);
  //   try {
  //     const data = {
  //       name: groupName,
  //     };
  //     const response = await AxiosInstance.post("module/customer/group", data);
  //     const results = response.data.results;

  //     setGroupName((prev) => [
  //       { ...results },
  //       ...(Array.isArray(prev) ? prev : []),
  //     ]);
  //     updateSettings({
  //       customerGroups: [
  //         { ...results },
  //         ...(Array.isArray(customerGroups) ? customerGroups : []),
  //       ],
  //     });
  //     onNewGroupsSet(results);
  //     showAlert("success", "Customer Group Added Successfull");
  //     setAddGroupLoad(false);
  //     handleNewGroupClose();
  //     setNewGroupName(results);
  //     openEditModal(isEditData);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setAddGroupLoad(false);
  //   }
  // };

  const openDeleteModal = (cItem) => {
    if (
      hasPermission("SUPPLIER", "SUPPLIER:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async () => {
    try {
      if (!checkNetwork()) return;
      // const data = { customerid: isDeleteData._id };
      await AxiosInstance.delete(`module/supplier/${isDeleteData._id}`);
      showAlert("success", Messages.SUCCESS.SUPPLIER_DELETED);
      //   setCustomerDetails((prevData) =>
      //    prevData.filter((customer) => customer._id !== isDeleteData._id)
      //  );
      OnDelete(isDeleteData);

      //  setTotalItems((prev) => prev - 1);

      // const newTotal = totalItems - 1;
      // const newTotalPages = Math.ceil(newTotal / perPage);

      // if (isCustomerData.length === 1 && currentPage > 0) {
      //   setCurrentPage((prev) => prev - 1);
      //   await handleListCustomer(currentPage - 1, isSearchTerm);
      // } else {
      //   await handleListCustomer(currentPage, isSearchTerm);
      // }

      // setTotalItems(newTotal);
      // setTotalPages(newTotalPages);
      setDeleteModalOpen(false);
      onClose();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECEIPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const getBgColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-honey";
      case "invoice":
        return "bg-label-moon";
      default:
        return "bg-label-secondary";
    }
  };

  const getBgTxtColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") return "bg-label-secondary";
    switch (salemode.toLowerCase()) {
      case "bill":
        return "bg-label-wave";
      case "invoice":
        return "bg-label-deep-purple";
      default:
        return "bg-label-secondary";
    }
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "submitted":
        return "bg-label-success"; // completed / confirmed
      case "draft":
        return "bg-label-warning"; // pending / editable
      default:
        return "bg-label-secondary";
    }
  };

  const handleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
  };

  if (!isOpen) return null;

  const formatCurrency = (value) => {
    const formatted = CurrencyConverter.toCurrency(Math.abs(value), "INR");
    return value < 0 ? `- ₹${formatted}` : `₹${formatted}`;
  };

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div className="modal show" style={{ display: "block" }}>
        <div className="modal-dialog  modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Supplier View</h5>
              <div className="d-flex align-items-center fw-bold text-dark mb-0 ms-auto me-2">
                <button
                  type="button"
                  className="btn btn-label-primary shadow-none  me-4 py-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    openEditModal(customerData);
                  }}
                >
                  <EditIcon iClass={"me-1"}/>Edit
                </button>
                <button
                  type="button"
                  className="btn-close border"
                  onClick={onClose}
                ></button>
              </div>
            </div>
            <div className="modal-body p-0 d-flex" style={{ height: "100%" }}>
              <div className="border-end" style={{ width: "170px" }}>
                <ul className="list-unstyled m-0 p-2">
                  {[
                    {
                      id: "customer",
                      label: " Overview",
                      icon: "bx bx-user",
                    },

                    {
                      id: "PurchaseCreditList",
                      label: "Purchase Details",
                      icon: "bx bxs-purchase-tag",
                    },

                    // ...(uRLs.DASHBOARD_PASSWORD === "true" &&
                    // (hasModulePermission("PASSWORD") ||
                    //   permission === undefined) &&
                    // activeStoreModules("PASSWORD")
                    //   ? [
                    //       {
                    //         id: "password",
                    //         label: "Password",
                    //         icon: "bx bx-key",
                    //       },
                    //     ]
                    //   : []),
                    // ...(uRLs.ESTIMATE_MODULE === "true" &&
                    // activeStoreModules("ESTIMATE") &&
                    // (hasModulePermission("ESTIMATE") ||
                    //   permission === undefined)
                    //   ? [
                    //       {
                    //         id: "estimate",
                    //         label: "Estimate Details",
                    //         icon: "bx bx-notepad",
                    //       },
                    //     ]
                    //   : []),
                    // {
                    //   id: "editcustomer",
                    //   label: "Edit Customer",
                    //   icon: "ng ng-ng-edit-icon",
                    // },
                    // {
                    //   id: "deletecustomer",
                    //   label: "Delete Customer",
                    //   icon: "ng ng-ng-delete-icon",
                    // },
                    // ...(uRLs.JOBCARD === "true" &&
                    // activeStoreModules("JOBCARD") &&
                    // (hasModulePermission("JOBCARD") || permission === undefined)
                    //   ? [
                    //       {
                    //         id: "jobCard",
                    //         label: "JobCard Details",
                    //         icon: "bx bx-id-card",
                    //       },
                    //     ]
                    //   : []),
                  ].map((tab) => (
                    <li
                      key={tab?.id}
                      onClick={() => setActiveTab(tab?.id)}
                      className={`p-2 mb-1 rounded cursor-pointer fw-bold d-flex align-items-center gap-2 ${
                        activeTab === tab?.id ? "text-primary" : "text-muted"
                      }`}
                      style={{
                        backgroundColor:
                          activeTab === tab?.id ? "#e8f0fe" : "transparent",
                        transition: "background-color 0.2s, color 0.2s",
                      }}
                      onMouseEnter={(e) => {
                        if (activeTab !== tab?.id) {
                          e.currentTarget.style.backgroundColor = "#f1f1f1";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (activeTab !== tab?.id) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      <i className={`${tab?.icon}`}></i> {/* Icon */}
                      {tab?.label}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Right Content */}
              <div className="px-3 py-1 flex-grow-1">
                {activeTab === "customer" && (
                  <>
                    {isCustomerLoading ? (
                      <div
                        className="d-flex justify-content-center align-items-center p-2"
                        style={{ minHeight: "200px" }}
                      >
                        <CircularProgress />
                      </div>
                    ) : customerData ? (
                      <div className="card shadow-sm border-0 rounded-3 p-3">
                        {/* Header with Name + Paylater */}
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <div className="fw-bold text-dark mb-0">
                            <UserIcon iClass={"fs-4 text-dark"}/>{" "}
                            <span className="fs-4">{customerData?.name}</span>
                            {/* <span className="ms-2">
                              <span
                                type="button"
                                className="btn-label-primary shadow-none p-1 rounded fs-6"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openEditModal(customerData?.customerData);
                                }}
                              >
                                <i className="ng ng-ng-edit-icon me-1"></i>Edit
                                Customer
                              </span>
                            </span> */}
                          </div>

                          {/* Paylater section */}
                          {customerData?.paylaterData && (
                            <div className="text-end">
                              <button
                                onClick={() => handleViewPaylater(customerData)}
                                className={`btn btn-deep-gray shadow-none " ${
                                  customerData?.paylaterData?.closeamount < 0
                                    ? "bg-label-danger text-white"
                                    : "bg-label-success text-white"
                                }`}
                                style={{
                                  cursor: "pointer",
                                }}
                              >
                                <TimerIcon iClass={"text-dark"}/>{" "}
                                <span className="fw-semibold text-dark">
                                  Paylater Amount:{" "}
                                </span>
                                <span
                                  className={`badge rounded-pill ${
                                    customerData?.paylaterData?.closeamount < 0
                                      ? "bg-label-danger text-white"
                                      : "bg-label-success text-white"
                                  }`}
                                >
                                  {formatCurrency(
                                    customerData?.paylaterData?.closeamount,
                                  )}
                                </span>
                              </button>
                            </div>
                          )}
                        </div>

                        {/* Phone */}

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <PhoneIcon  iClass={"fs-15 text-muted"}/>
                          <span className="fw-semibold text-muted">
                            Number:
                          </span>
                          <span className="text-dark">
                            {customerData?.number || "-"}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <EnvelopeIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">Email:</span>
                          <span className="text-dark">
                            {customerData?.email || "-"}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <HomeIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">
                            Address:
                          </span>
                          <span className="text-dark">
                            {customerData?.addressline1 || ""}
                            {customerData?.addressline2
                              ? `, ${customerData?.addressline2}`
                              : ""}{" "}
                            {customerData?.district || ""}{" "}
                            {customerData?.country || ""} -{" "}
                            {customerData?.pincode || ""}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <MapIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">State:</span>
                          <span className="text-dark">
                            {customerData?.state || "-"}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <CreditCardIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">GST:</span>
                          <span className="text-dark">
                            {customerData?.gstnumber || "-"}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <BuildingIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">CIN:</span>
                          <span className="text-dark">
                            {customerData?.cinnumber || "-"}
                          </span>
                        </div>

                        <div className="mb-2 d-flex align-items-center gap-2">
                          <IdCardIcon iClass={"fs-5 text-muted"}/>
                          <span className="fw-semibold text-muted">PAN:</span>
                          <span className="text-dark">
                            {customerData?.pannumber || "-"}
                          </span>
                        </div>
                        <div className="order-actions d-flex align-items-center justify-content-end gap-2">
                          <button
                            type="button"
                            className="btn-label-danger shadow-none me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(customerData);
                            }}
                          >
                            <DeleteIcon/>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <p>No customer details found.</p>
                    )}
                  </>
                )}

                {activeTab === "PurchaseCreditList" && (
                  <>
                    {isSalesLoading ? (
                      <div className="table-responsive ">
                        <table className="table align-middle mb-0">
                          <tbody>
                            {[...Array(perPage)].map((_, index) => (
                              <tr key={index}>
                                {[...Array(8)].map((__, i) => (
                                  <td key={i} className="text-center">
                                    <Skeleton
                                      variant="text"
                                      width={i === 0 ? 50 : 100}
                                    />
                                  </td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : salesData?.length > 0 ? (
                      <div className="table-responsive mt-3">
                        <table className="table align-middle mb-0">
                          <thead className="table-light text-center">
                            <tr>
                              <th>S.No</th>
                              <th>Purchase No</th>
                              <th>Purchase Date</th>
                              <th>Purchase Items</th>
                              <th> Total</th>
                              <th>Credit</th>
                              <th>Paid</th>
                              <th>Status</th>
                              {/* <th>Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {salesData?.map((sale, index) => (
                              <tr
                                key={sale._id || index}
                                className="cursor-poInter hover-row"
                                onClick={() => handleView(sale)}
                              >
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">
                                  {sale.purchaseNo}
                                </td>
                                <td className="text-center">
                                  <div className="d-flex flex-column">
                                    <span className="text-nowrap text-heading fw-medium">
                                      {
                                        DateConverter?.ISOToDisplayFormat(
                                          DateConverter?.convertToTimeZone(
                                            sale?.purchaseDate,
                                            "Asia/Kolkata",
                                          ),
                                        )?.date
                                      }
                                    </span>
                                  </div>
                                </td>
                                <td className="text-center">
                                  {(sale?.purchaseItems?.length || 0) +
                                    (sale?.purchaseServices?.length || 0)}{" "}
                                  Item(s)
                                </td>
                                <td className="text-end">
                                  {formatCurrencyFun(sale?.totalAmount)}
                                </td>
                                <td className="text-end">
                                  {formatCurrencyFun(sale?.creditAmount)}
                                </td>
                                <td className="text-end tdPadding">
                                  {formatCurrencyFun(sale?.totalPaid)}
                                </td>
                                <td className="text-center w-15">
                                <div className="no-print position-relative">
                                   <div className=" d-flex justify-content-center align-items-center">
                                  <span
                                    className={`stock-status-badge badge ${getColor(sale?.status)}`}
                                  >
                                    {sale?.status}
                                  </span>
                                  <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                    <button
                                      type="button"
                                      className="btn-label-info shadow-none me-2"
                                      onClick={() => handleView(sale)}
                                      disabled={
                                        buttonLoading?.id === sale?._id &&
                                        buttonLoading?.type === "view"
                                      }
                                    >
                                      {buttonLoading?.id === sale?._id &&
                                      buttonLoading?.type === "view" ? (
                                        <CircularProgress
                                          size={20}
                                          className="text-primary"
                                        />
                                      ) : (
                                        <ShowIcon/>
                                      )}
                                    </button>
                                    {sale?.status === "DRAFT" && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn-label-primary shadow-none me-2"
                                          onClick={() => handleEdit(sale)}
                                          disabled={
                                            buttonLoading?.id === sale?._id &&
                                            buttonLoading?.type === "edit"
                                          }
                                        >
                                          {buttonLoading?.id === sale?._id &&
                                          buttonLoading?.type === "edit" ? (
                                            <CircularProgress
                                              size={20}
                                              className="text-primary"
                                            />
                                          ) : (
                                            <EditIcon/>
                                          )}
                                        </button>
                                      </>
                                    )}
                                    {/* {sale?.status === "ACTIVE" && (
                                      <button
                                        type="button"
                                        className="btn-label-danger shadow-none me-2"
                                        onClick={() => openDeleteModal(sale)}
                                      >
                                        <i className="ng ng-ng-delete-icon"></i>
                                      </button>
                                    )} */}
                                  </div>
                                  </div>
                                  </div>
                                </td>
                                {/* <td className="text-center">
                                  <div className="order-actions opacity-0 opacity-md-100">
                                    <button
                                      type="button"
                                      className="btn-label-info shadow-none me-2"
                                      onClick={() => handleView(sale)}
                                      disabled={
                                        buttonLoading?.id === sale?._id &&
                                        buttonLoading?.type === "view"
                                      }
                                    >
                                      {buttonLoading?.id === sale?._id &&
                                      buttonLoading?.type === "view" ? (
                                        <CircularProgress
                                          size={20}
                                          className="text-primary"
                                        />
                                      ) : (
                                        <i className="bx bx-show"></i>
                                      )}
                                    </button>
                                    {sale?.status === "DRAFT" && (
                                      <>
                                        <button
                                          type="button"
                                          className="btn-label-primary shadow-none me-2"
                                          onClick={() => handleEdit(sale)}
                                          disabled={
                                            buttonLoading?.id === sale?._id &&
                                            buttonLoading?.type === "edit"
                                          }
                                        >
                                          {buttonLoading?.id === sale?._id &&
                                          buttonLoading?.type === "edit" ? (
                                            <CircularProgress
                                              size={20}
                                              className="text-primary"
                                            />
                                          ) : (
                                            <i className="ng ng-ng-edit-icon"></i>
                                          )}
                                        </button>
                                      </>
                                    )}
                                    {sale?.status === "ACTIVE" && (
                                      <button
                                        type="button"
                                        className="btn-label-danger shadow-none me-2"
                                        onClick={() => openDeleteModal(sale)}
                                      >
                                        <i className="ng ng-ng-delete-icon"></i>
                                      </button>
                                    )}
                                  </div>
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>No credit found.</p>
                    )}

                    {totalPages > 0 && (
                      <div className="d-flex justify-content-center mt-3">
                        <ReactPaginate
                          previousLabel={"← Previous"}
                          nextLabel={"Next →"}
                          breakLabel={"..."}
                          onPageChange={({ selected }) =>
                            setCurrentPage(selected)
                          }
                          pageRangeDisplayed={5}
                          pageCount={totalPages}
                          containerClassName="pagination"
                          pageClassName="page-item"
                          pageLinkClassName="page-link"
                          previousClassName="page-item"
                          previousLinkClassName="page-link"
                          nextClassName="page-item"
                          nextLinkClassName="page-link"
                          breakClassName="page-item"
                          breakLinkClassName="page-link"
                          activeClassName="active"
                          forcePage={currentPage}
                        />
                      </div>
                    )}
                  </>
                )}

                {activeTab === "password" && (
                  <PasswordManager customerId={supplierId} />
                )}
                {uRLs.ESTIMATE_MODULE === "true" &&
                  activeStoreModules("ESTIMATE") &&
                  (hasModulePermission("ESTIMATE") ||
                    permission === undefined) &&
                  blockedPermissions("ESTIMATE:list") &&
                  permission === undefined &&
                  activeTab === "estimate" && (
                    <EstimateList customerId={supplierId} />
                  )}

                {activeTab === "jobCard" && (
                  <JobCardList customerId={supplierId} />
                )}
                {/* {
                    activeTab === "editcustomer" && (
                    <div className="">
                      <button
                          type="button"
                          onClick={() => customerData?.customerData && openEditModal(customerData?.customerData)}
                          className="btn btn-primary mt-2 mt-lg-0"
                        >
                          <i className="ng ng-ng-edit-icon"></i> Edit Customer
                        </button>
                    </div>
                      )
                  } */}
                {/* {
                    activeTab === "deletecustomer" && (
                      <>
                      <div>
                      <button
                    type="button"
                    onClick={() => customerData?.customerData && openDeleteModal(customerData?.customerData)}
                    className="btn btn-danger mt-2 mt-lg-0"
                  >
                    <i className="bx bx-trash"></i> Delete Customer
                  </button></div>
                  </>
                      )
                  } */}
              </div>
            </div>
            {/* {templateId === "PROFESSIONALGST" && isViewModalOpen && (
              <ProfessionalGSTInvoice
                isData={isViewData}
                selectedOption={templateId}
                onClose={handleClose}
                onDataUpdate={async () => {
                  const data = await handleSaleItems(isViewData?._id);
                  if (data) setViewData(data);
                }}
                onDataChange={true}
              />
            )}
            {templateId === "ESSENTIAL" && isViewModalOpen && (
              <EssentialInvoice
                isData={isViewData}
                selectedOption={templateId}
                onClose={handleClose}
                onDataUpdate={async () => {
                  const data = await handleSaleItems(isViewData?._id);
                  if (data) setViewData(data);
                }}
                onDataChange={true}
              />
            )} */}

            {isViewModalOpen && (
               <TemplateModalLayout
                isOpen={isViewModalOpen}
                isData={isViewData}
                onClose={handleClose}
                onEdit={handleEdit}
                selectedOption={selectedPurchaseOption}
                setSelectedOption={setSelectedPurchaseOption}         
                isPurchase={true}
                />
              // <PurchaseView
              //   data={isViewData}
              //   onClose={handleClose}
              //   onEdit={handleEdit}
              //   // onDone={handleDone}
              // />
            )}
            {/* {isDeleteModalOpen && (
              <DeleteModal
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                isLable={" Sale " + isDeleteData?.saleno}
                isBtnLoading={isBtnLoading}
              />
            )} */}

            {isSelectedPlater && (
              <ViewPaylater
                isData={isSelectedPlater}
                onClose={handleClosePaylater}
                isBtnLoading={isBtnLoading}
                onDataUpdate={handleDataUpdate}
              />
            )}

            {isDeleteModalOpen && (
              <DeleteModal
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDelete}
                isLable={" Supplier " + isDeleteData?.name}
                isBtnLoading={isBtnLoading}
              />
            )}

            {isEditModalOpen && (
              <EditCutomer
                editData={isEditData}
                onClose={closeEditModal}
                onEdit={handleUpdte}
                isBtnLoading={isBtnLoading}
                groupId={groupId}
                selectedGroupDetails={selectedGroupDetails}
                onEditGroupData={onEditGroupData}
                groupName={groupName}
                onChangeGroup={onChangeGroup}
                // onNewGroupsIn={handleCustomerGroupAdd}
                // resetAll={true}
                newGroup={newGroupName}
                error={error}
                setErrors={setErrors}
              />
            )}
            <div className="modal-footer d-block ">
              <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <XIcon/> Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
